import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

function OTPPopup({ onClose, handleSubmit, userEmail, setFormNum }) {
  const [otp, setOtp] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const inputRefs = useRef([]);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const handleInput = (e, index) => {
    const { value } = e.target;
    const newOtp = otp.split("");
    newOtp[index] = value;
    setOtp(newOtp.join(""));

    if (value.length >= 1 && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    } else if (value.length === 0 && index > 0 && e.key === "Backspace") {
      inputRefs.current[index - 1].focus();
    }
  };

  async function handleOTPSubmit(e) {
    console.log("Submitted OTP:", otp);

    if (otp.length !== 4 || isNaN(otp)) {
      alert("Please enter a valid 4-digit OTP.");
      return;
    }
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("myotp", otp);
      formDataToSend.append("user_email", userEmail);
      // console.log("User Email:", userEmail);

      const response = await axios.post(
        "/api/verifyotp.php",
        formDataToSend
      );
      // console.log("Response:", response.data);
      // console.log(response);
      if (response.data.status === "otp verified!!") {
        // console.log("verification succesful");
        await handleSubmit(e);
        handleClose();
        setFormNum(1)
      } else {
        alert(response.data?.status || "OTP verification failed.");
      }
    } catch (error) {
      console.error(
        "Error Details:",
        error.response?.data || error.message || "Unknown error"
      );
      alert("An error occurred while verifying OTP. Please try again.");
    }
  }

  return (
    <div
      className={`fixed inset-0 flex justify-center items-center z-50 transition-opacity duration-1000 font-inter ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
      style={{
        backdropFilter: "blur(5px)",
        WebkitBackdropFilter: "blur(5px)",
      }}
    >
      <div
        className={`w-full max-w-xs sm:max-w-sm xl:max-w-xl bg-white px-4 sm:px-6 sm:pt-8 border shadow-xl p-10 rounded-md transform transition-all duration-300 ${
          isVisible ? "scale-100" : "scale-95"
        }`}
      >
        <label
          htmlFor="otp"
          className="pt-2 text-center block text-sm md:text-base 2xl:text-xl text-[#111827] mb-4 2xl:mb-4"
        >
          Please enter the OTP sent to your email.
        </label>
        <div className="p-3 px-4 border border-[#CAD0D9] rounded-md mt-1 mb-4">
          <div className="flex justify-between gap-4 mx-4">
            {[...Array(4)].map((_, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                className="w-full text-center 2xl:text-lg border-b-2 border-[#A9A9A9] text-black sm:text-sm xl:text-base focus:outline-none focus:border-black"
                required
                ref={(el) => (inputRefs.current[index] = el)}
                onInput={(e) => handleInput(e, index)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") { 
                    handleOTPSubmit(e);
                  }if (e.key === "Backspace" && e.target.value === "") {
                    if (index > 0) inputRefs.current[index - 1].focus();
                  }
                }}
              />
            ))}
          </div>
        </div>
        <button
          type="submit"
          onClick={handleOTPSubmit}
          className="w-full px-4 py-2 2xl:py-3 2xl:text-lg 2xl:mb-4 text-white bg-[#006A4E] rounded-lg hover:bg-[#4B4B4B] transition-colors"
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default OTPPopup;